import { render, staticRenderFns } from "./editnews.vue?vue&type=template&id=8cafdf20&scoped=true&"
import script from "./editnews.vue?vue&type=script&lang=js&"
export * from "./editnews.vue?vue&type=script&lang=js&"
import style0 from "./editnews.vue?vue&type=style&index=0&id=8cafdf20&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cafdf20",
  null
  
)

export default component.exports